import React from "react";
import style from "@styles/MyCardTotalStateStyle.module.css";
import { useSelector } from "react-redux";

import CardGradeByUser from "../components/CardGradeByUser";

import { useGetMyGalleryTotalSateQuery } from "./useGetMyGalleryTotalSateQuery";

export const  MySaleCardTotalState = () => {
  const { user } = useSelector((state) => state.auth);
  const { data } = useGetMyGalleryTotalSateQuery();

  const nickname = user?.nickname;
  const totalCount = data?.totalCount || 0;
  const gradeData = data?.gradeCount;

  return (
    <>
      <section className={style.sectionUserState}>
        <header className={style.SaleState}>
          <p>{`${nickname}님이 보유한 포토카드`}</p>
          <p
            className={style.totalPhotoCount}
          >{`(${totalCount}장)`}</p>
        </header>
        <section className={style.gradeContainer}>
          {gradeData?.["COMMON"] && <CardGradeByUser grade="COMMON" count={gradeData["COMMON"]} />}
          {gradeData?.["RARE"] && <CardGradeByUser grade="RARE" count={gradeData["RARE"]} />}
          {gradeData?.["SUPER RARE"] && <CardGradeByUser grade="SUPER RARE" count={gradeData["SUPER RARE"]} />}
          {gradeData?.["LEGENDARY"] && <CardGradeByUser grade="LEGENDARY" count={gradeData["LEGENDARY"]} />}
        </section>
      </section>
    </>
  );
}

export default MySaleCardTotalState;